import { useEffect } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import ValidateEmail from "../admin/userProfile/components/ValidateEmail";
import getAbsoluteLogoURL from "global/helpers";

type Props = {
  userID: string;
};
const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add("bg-white");
    return () => {
      document.body.classList.remove("bg-white");
    };
  }, []);

  return (
    <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed">
      {/* begin::Content */}
      <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
        {/* begin::Logo */}
        <span className="mb-12">
          <img alt="Logo" src={getAbsoluteLogoURL()} className="proptimo-logo-large" />
        </span>
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className="bg-white rounded shadow-sm p-10 p-lg-15">
          <Outlet />
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      <div className="d-flex flex-center flex-column-auto p-10">
        <div className="d-flex align-items-center fw-bold fs-6">
          <span className="text-muted text-hover-primary px-2">About</span>

          <span className="text-muted text-hover-primary px-2">Contact</span>
        </div>
      </div>
      {/* end::Footer */}
    </div>
  );
};

const EmailVerification: React.FC<Props> = ({ userID }) => {
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path="verifyemail" element={<ValidateEmail userID={userID!} />} />
        <Route index element={<ValidateEmail userID={userID!} />} />
      </Route>
    </Routes>
  );
};

export default EmailVerification;
